import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import reportsService from '../../services/reportsService'

export const fetchReportData = createAsyncThunk(
  'reports/fetchAll',
  async (dateRange = '7d', { rejectWithValue }) => {
    try {
      const params = { date_range: dateRange }

      const [volume, trend, alertTrend, summary] = await Promise.all([
        reportsService.getHourlyVolume(params),
        reportsService.getApprovalBlockTrend(params),
        reportsService.getAlertTrend(params),
        reportsService.getSummary(params),
      ])

      return { volume, trend, alertTrend, summary }
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || e.message)
    }
  }
)

const reportsSlice = createSlice({
  name: 'reports',
  initialState: {
    volume: [],
    trend: [],
    alertTrend: [],
    summary: null,
    loading: false,
    error: null,
    dateRange: '7d',
  },
  reducers: {
    setDateRange(state, { payload }) {
      state.dateRange = payload
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchReportData.pending, (s) => {
      s.loading = true
      s.error = null
    })

    b.addCase(fetchReportData.rejected, (s, a) => {
      s.loading = false
      s.error = a.payload
    })

    b.addCase(fetchReportData.fulfilled, (s, a) => {
      s.loading = false
      s.volume = a.payload.volume?.data ?? []
      s.trend = a.payload.trend?.data ?? []
      s.alertTrend = a.payload.alertTrend?.data ?? []
      s.summary = a.payload.summary ?? null
    })
  },
})

export const { setDateRange } = reportsSlice.actions

export const selectReports = (s) => s.reports
export const selectReportLoading = (s) => s.reports.loading
export const selectReportError = (s) => s.reports.error
export const selectDateRange = (s) => s.reports.dateRange

export default reportsSlice.reducer